'use client';

import React, { useState } from 'react';
import { ActionDrawer } from '@/components/actiondrawer/actiondrawer';
import { Finder } from '@/components/locationfinder/finder';

import 'maplibre-gl/dist/maplibre-gl.css';

import { CsoMarkers } from '@/components/markers/csomarkers/csomarkers';
import { SudsMarkers } from '@/components/markers/sudsmarkers/sudsmarkers';
import { useMapContext } from '@/contexts/MapContext';
import { CatchmentModal } from '../catchmentmodal/CatchmentModal';
import { SuggestedSudsDrawer } from '../markers/SuggestedSudsDrawer/SuggestedSudsDrawer';
import { SuggestedSudsMarkers } from '../markers/suggestedsudsmarkers/SuggestedSudsMarkers';
import { OptimalModeLoading } from '../optimalloading/OptimalModeLoading';

const MARKER_Z_INDEX = {
  suds: '2',
  suggestedSuds: '3',
  cso: '4',
};

export function Map() {
  const { mapContainer, isOptimalMode, isOptimalModeLoaded } = useMapContext();

  const [isInitialCatchmentComplete, setIsInitialCatchmentComplete] = useState<boolean>(false);

  return (
    <div style={{ width: '100vw', height: 'calc(100vh - 59px)', position: 'relative' }}>
      <div style={{ position: 'absolute', top: 24, left: 24, zIndex: 10 }}>
        <Finder />
      </div>
      {!isInitialCatchmentComplete && (
        <CatchmentModal setComplete={setIsInitialCatchmentComplete} />
      )}
      <div ref={mapContainer} style={{ width: '100%', height: '100%' }} />
      <SudsMarkers zIndex={MARKER_Z_INDEX.suds} />
      <SuggestedSudsMarkers zIndex={MARKER_Z_INDEX.suggestedSuds} />
      <SuggestedSudsDrawer />
      <CsoMarkers zIndex={MARKER_Z_INDEX.cso} />
      <ActionDrawer />
      {isOptimalMode && !isOptimalModeLoaded && <OptimalModeLoading />}
    </div>
  );
}
